import { BooleanParam, useQueryParam } from 'use-query-params';

// Short-term gate: the Export data chooser stays off until Release 3 unless this URL parameter is set.
export const EXPERIMENTAL_RESULTS_EXPORT_PARAM = 'experimentalResultsExport';

export const useExperimentalResultsExport = (): boolean => {
  const [isExperimentalResultsExport] = useQueryParam(EXPERIMENTAL_RESULTS_EXPORT_PARAM, BooleanParam);
  return Boolean(isExperimentalResultsExport);
};
